var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnsucessful(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Unsucessful",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 51.385,
    height: 51.385,
    viewBox: "0 0 51.385 51.385",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.123,
    y1: 0.146,
    x2: 0.912,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff6f98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f53d62"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Base",
    cx: 25.693,
    cy: 25.693,
    r: 25.693,
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Base-2",
    "data-name": "Base",
    cx: 23.637,
    cy: 23.637,
    r: 23.637,
    transform: "translate(2.055 2.055)",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(20.284 20.284)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M11.269,0,0,11.269",
    fill: "none",
    stroke: "#f53d62",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    "data-name": "Shape",
    d: "M0,0,11.269,11.269",
    fill: "none",
    stroke: "#f53d62",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnsucessful);
export default __webpack_public_path__ + "static/media/unsucessful.5021394dd33d7e11d6303417f8fc5ec0.svg";
export { ForwardRef as ReactComponent };